import { useEffect, useState } from 'react';
import { useOnboardingStatus } from '../hooks/use-dossier-company';
import { OnboardingWizard } from './onboarding-wizard';

/**
 * Sprint 5b.1 v2 — Phase D.2 : trigger automatique du wizard onboarding.
 *
 * Monté au niveau MainLayout. Affiche le wizard si :
 *   - `onboardingCompanyDossierAt IS NULL` (jamais vu)
 *   - ET `role = tenant_admin`
 *
 * Une fois ouvert, persiste tant que l'utilisateur n'a pas cliqué « Quitter »
 * ou « Terminer » (la fermeture appelle `useDismissOnboarding` qui pose le
 * timestamp et n'est jamais réinitialisé).
 */
export function OnboardingTrigger() {
  const { data: status, isLoading } = useOnboardingStatus();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isLoading || !status) return;
    const shouldOpen =
      status.onboardingCompanyDossierAt === null &&
      (status.role === 'tenant_admin' || status.role === 'admin');
    if (shouldOpen) setOpen(true);
  }, [status, isLoading]);

  return <OnboardingWizard open={open} onClose={() => setOpen(false)} />;
}
